import { useEffect, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';

export function useQuoteUserRole() {
  const [user, authLoading] = useAuthState(auth);
  const [userRole, setUserRole] = useState('');
  const [currentUserUid, setCurrentUserUid] = useState('');
  const [isVendor, setIsVendor] = useState(false);
  const [roleFetched, setRoleFetched] = useState(false);

  useEffect(() => {
    if (authLoading) return;

    if (!user) {
      setCurrentUserUid('');
      setUserRole('');
      setIsVendor(false);
      setRoleFetched(true);
      return;
    }

    let active = true;

    const loadRole = async () => {
      setCurrentUserUid(user.uid);
      try {
        const docSnap = await getDoc(doc(db, 'users', user.uid));
        if (!active) return;
        if (docSnap.exists()) {
          const userData = docSnap.data();
          setUserRole(userData.role || '');
          setIsVendor(Boolean(userData.vendor));
        } else {
          setUserRole('');
          setIsVendor(false);
        }
      } catch (error) {
        console.error('Error loading user role:', error);
        if (active) {
          setUserRole('');
          setIsVendor(false);
        }
      } finally {
        if (active) setRoleFetched(true);
      }
    };

    loadRole();

    return () => {
      active = false;
    };
  }, [user, authLoading]);

  return {
    user,
    authLoading,
    userRole,
    currentUserUid,
    isVendor,
    roleFetched,
  };
}
